import { AppProps } from 'next/app';
import { ThemeProvider } from '@mui/material/styles';
import Page from '@/components/layout/Page';
import 'maplibre-gl/dist/maplibre-gl.css';
import '@/styles/globals.css';
import '@/styles/fonts.css';
import '@/styles/maplibre.css';
import '@/styles/externalLibraries.css';
import { MapTypeProvider } from '@/hooks/useMapType';
import { Toaster } from '@/components/shadcn/sonner';
import { darkTheme } from '@/legacy/themes/darkTheme';
import { ToasterProvider } from '@/hooks/useToaster';

interface AppExtendedProps extends AppProps {}

export default function App({ Component, pageProps }: AppExtendedProps) {
  const { ...rest } = pageProps;

  return (
    <>
      <ThemeProvider theme={darkTheme}>
        <MapTypeProvider>
          <ToasterProvider>
            <Page>
              <Component {...rest} />
              <Toaster />
            </Page>
          </ToasterProvider>
        </MapTypeProvider>
      </ThemeProvider>
    </>
  );
}
